module.exports = __webpack_public_path__ + "static/media/luminaria.6e105cc3.jpg";